import { render, staticRenderFns } from "./PillSwitch.vue?vue&type=template&id=72012878&scoped=true&"
import script from "./PillSwitch.vue?vue&type=script&lang=js&"
export * from "./PillSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PillSwitch.vue?vue&type=style&index=0&id=72012878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72012878",
  null
  
)

export default component.exports